import * as type from './constant';

export const getBudgetCategory = (params = undefined, selfRole = undefined) => ({
  type: type.GET,
  params,
  selfRole,
});

export const getBudgetCategorySuccess = (payload) => ({
  type: type.GET_SUCCESS,
  payload,
});

export const getBudgetCategoryError = (error) => ({
  type: type.GET_ERROR,
  error,
});

export const addBudgetCategory = (payload, selfRole = undefined) => ({
  type: type.ADD,
  payload,
  selfRole
});

export const addBudgetCategorySuccess = (payload) => ({
  type: type.ADD_SUCCESS,
  payload,
});

export const updateBudgetCategory = (id, payload, selfRole = undefined) => ({
  type: type.UPDATE,
  id,
  payload,
  selfRole,
});

export const updateBudgetCategorySuccess = (payload) => ({
  type: type.UPDATE_SUCCESS,
  payload,
});

export const deleteBudgetCategory = (ids, selfRole = undefined) => ({
  type: type.DELETE,
  ids,
  selfRole,
});

export const deleteBudgetCategorySuccess = (payload) => ({
  type: type.DELETE_SUCCESS,
  payload,
});

export const manipulationBudgetCategoryError = (error) => ({
  type: type.MANIPULATION_ERROR,
  error,
});
